/* unplugin-vue-components disabled */import __unplugin_components_3 from '~icons/mdi/email';
import __unplugin_components_2 from '~icons/mdi/whatsapp';
import __unplugin_components_1 from '~icons/mdi/arrow-right-bold';
import __unplugin_components_0 from '~icons/mdi/chevron-down';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    { attrs: { dense: "" } },
    [
      _vm._l(_vm.items, function (item) {
        return [
          item.children.length < 1
            ? _c(
                "v-list-item",
                { key: item.title, attrs: { href: item.to, exact: "" } },
                [
                  _c("v-list-item-icon", {
                    domProps: { innerHTML: _vm._s(item.icon) },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v(_vm._s(item.title))])],
                    1
                  ),
                ],
                1
              )
            : _c(
                "v-list-group",
                {
                  key: item.title,
                  staticClass: "group",
                  attrs: { "active-class": "grey--text", "no-action": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function () {
                          return [
                            _c("v-list-item-icon", {
                              domProps: { innerHTML: _vm._s(item.icon) },
                            }),
                            _vm._v(" "),
                            _c(
                              "v-list-item-title",
                              { attrs: { title: item.title } },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.title) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "appendIcon",
                        fn: function () {
                          return [_c(__unplugin_components_0)]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._l(item.children, function (children) {
                    return [
                      _c(
                        "v-list-item",
                        {
                          key: children.title,
                          attrs: {
                            link: "",
                            "active-class": "grey--text",
                            href: children.to,
                            title: children.title,
                            exact: "",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c(__unplugin_components_1, {
                                staticStyle: { "font-size": "20px" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(children.title)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  }),
                ],
                2
              ),
        ]
      }),
      _vm._v(" "),
      _c("v-divider", { staticClass: "my-lg-3 my-2" }),
      _vm._v(" "),
      _c("v-subheader", [_vm._v("Contate-nos:")]),
      _vm._v(" "),
      _c(
        "v-list-item",
        {
          attrs: {
            title: "agendar consulta por whatsapp",
            href: _vm.openWhats(),
            target: "_blank",
          },
        },
        [
          _c("v-list-item-icon", [_c(__unplugin_components_2)], 1),
          _vm._v(" "),
          _c("v-list-item-title", [_vm._v("Whatsapp")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list-item",
        { attrs: { title: "agendar consulta por email", href: "contato" } },
        [
          _c("v-list-item-icon", [_c(__unplugin_components_3)], 1),
          _vm._v(" "),
          _c("v-list-item-title", [_vm._v("Email")]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }